/* eslint-disable react/sort-comp */
import React from 'react';
import { BackHandler } from 'react-native';
import { Device } from 'DeviceUtils';
import { IconBackWithText } from '../../../../runtime/Navigation/navigationHeaderIcons';
import pubSub from '../../../../pubSub';
import { ACTION } from '../../../../pubSub/actions';
import NavigationService from '../../../../runtime/Navigation/navigationService';

class EpgBackHandler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDatePickerDisplayed: false
        };
        this.subscriberId = 'epg-nav-back-button-component';
        pubSub.subscribe(ACTION.ON_EPG_DATE_SELECT, this.changeDatePickerState, this.subscriberId);
    }

    componentDidMount() {
        this.backHandler = BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        pubSub.unsubscribe(this.subscriberId);
        this.backHandler.remove();
    }

    handleBackPress = () => {
        const { isDatePickerDisplayed } = this.state;
        if (isDatePickerDisplayed && !Device.isTablet) {
            pubSub.dispatch(ACTION.ON_EPG_DATE_SELECT, {});
            this.setState({ isDatePickerDisplayed: !isDatePickerDisplayed });
        } else {
            NavigationService.getAppNavigationInstance().pop();
        }

        return true;
    };

    changeDatePickerState = ({ toggle = true }) => {
        const { isDatePickerDisplayed } = this.state;
        if (toggle) {
            this.setState({ isDatePickerDisplayed: !isDatePickerDisplayed });
        }
    };

    render() {
        return (
            <IconBackWithText
                testID="back_button"
                key="arrow_left"
                onPress={this.handleBackPress}
            />
        );
    }
}

export default EpgBackHandler;
